import 'bootstrap';
import 'js/jquery.cookie';
import 'js/jquery.awesomeCloud';
import 'js/jquery.equalheights';
import 'js/rating';
import 'js/theme';
import $ from 'jquery';
import './photopile';

window.jQuery = $;
